<ul class="nav nav-pills pb-3 pb-md-2 nav-pills-overflow gap-1 gap-md-2">
  <li class="nav-item" *ngFor="let lang of getFilters()">
    <a class="btn rounded-pill nav-link px-2 px-md-3 py-2 mb-2"
       (click)="setCourse(lang)"
       [ngClass]="isActive(lang) ? 'active' : ''">
      {{ getLanguageTranslation(lang) | translate }}
    </a>
  </li>
</ul>
